import { QueryOptions, useFetch, UseFetchOptions } from '@shared/fetch-utils';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from './AuthContext';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';
import { useAuth0 } from '@auth0/auth0-react';
import { handleFetchErrorWithTokenRefresh } from '@retail/utils';
import { MpeTenantKey, MyOrgUnitAssortmentsDTO } from '@retail/auth/types';

interface Props extends QueryOptions {
  brandId: string;
  tenantAppKey: MpeTenantKey;
}

export function useFetchMyAssortmentApi({ brandId, tenantAppKey, ...queryOptions }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();
  const { getAccessTokenSilently } = useAuth0();

  const baseOptions: UseFetchOptions & QueryOptions = {
    method: 'GET',
    queryKey: ['my-assortments', brandId, token],
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.brands.brand.myAssortments.getFullLinkPath({ brandId }),
    }),
    headers: {
      'X-Tenant': tenantAppKey,
    },
    ...queryOptions,
  };

  return useFetch<MyOrgUnitAssortmentsDTO>({
    ...baseOptions,
    onRejected: handleFetchErrorWithTokenRefresh(getAccessTokenSilently, baseOptions),
    token,
  });
}
